import { render, staticRenderFns } from "./ReturnActionsModals.vue?vue&type=template&id=52025522"
import script from "./ReturnActionsModals.vue?vue&type=script&lang=js"
export * from "./ReturnActionsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports